import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['allContexts', 'context', 'allAgents', 'agent']
  static classes = ['active', 'inactive']

  connect() {
    this.refresh()
  }

  toggleAllContexts() {
    const allChecked = this.contextTargets.every(cb => cb.checked)
    this.contextTargets.forEach(cb => (cb.checked = !allChecked))
    this.refresh()
  }

  toggleContext(event) {
    const checkbox = event.currentTarget.previousElementSibling
    checkbox.checked = !checkbox.checked
    this.refresh()
  }

  toggleAllAgents() {
    const allChecked = this.agentTargets.every(cb => cb.checked)
    this.agentTargets.forEach(cb => (cb.checked = !allChecked))
    this.refresh()
  }

  toggleAgent(event) {
    const checkbox = event.currentTarget.previousElementSibling
    checkbox.checked = !checkbox.checked

    if (this.hasAgentTarget && this.agentTargets.every(cb => !cb.checked)) {
      this.agentTargets.forEach(cb => (cb.checked = true))
    }

    this.refresh()
  }

  refresh() {
    if (this.hasAllContextsTarget) {
      const allOn = this.hasContextTarget && this.contextTargets.every(cb => cb.checked)
      this.styleBadge(this.allContextsTarget, allOn)
    }

    this.contextTargets.forEach(cb => {
      this.styleBadge(cb.nextElementSibling, cb.checked)
    })

    if (this.hasAllAgentsTarget) {
      const allOn = !this.hasAgentTarget || this.agentTargets.every(cb => cb.checked)
      this.styleBadge(this.allAgentsTarget, allOn)
    }

    this.agentTargets.forEach(cb => {
      this.styleBadge(cb.nextElementSibling, cb.checked)
    })
  }

  remove(event) {
    const item = event.currentTarget.closest('[id^=faq-item]')
    if (item) {
      item.remove()
    }
  }

  styleBadge(el, active) {
    if (!el) return
    const on = this.activeClasses
    const off = this.inactiveClasses

    if (active) {
      el.classList.remove(...off)
      el.classList.add(...on)
    } else {
      el.classList.remove(...on)
      el.classList.add(...off)
    }
  }
}
